import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmModalComponent } from 'src/app/shared/confirm-modal/confirm-modal.component';
import { VssEvent } from 'src/app/shared/models/vss-event.module';
import { VssEventsService } from './vss-events.service';

@Component({
    selector: 'app-vss-events',
    templateUrl: './vss-events.component.html',
    styleUrls: ['./vss-events.component.css'],
    standalone: false
})
export class VssEventsComponent implements OnInit {

  @ViewChild('confirmModal') confirmModal: ConfirmModalComponent;

  public currentOrganizationId: number;
  public currentLang: string;
  public events: VssEvent[] = [];
  public icons: { [name: string]: any } = {
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt
  };

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _vssEventsService: VssEventsService,
    private _translate: TranslateService) { }

  ngOnInit(): void {
    this.currentLang = this._translate.currentLang.toLowerCase();
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/vss']);
    }
    this.currentOrganizationId = urlPramas.orgId;
    this._vssEventsService.getVssOrganizationEvents(this.currentOrganizationId.toString()).subscribe((result: VssEvent[]) => {
      console.log(result);
      this.events = result;
    });
  }

  public onEventDelete(eventId: number, index: number) {
    this.confirmModal.open(this._translate.instant('VSS.EVENTS.deleteEvent'), this._translate.instant('VSS.EVENTS.deleteEventQuestion'));
    this.confirmModal.confirmationResult.subscribe(result => {
      if (result) {
        this._vssEventsService.deleteVssEvent(eventId).subscribe(deleteResult => {
          this.events.splice(index, 1);
        });
      }
    });
  }

}
